import React from "react";
import { Mail, MessageCircle, Smartphone, BellRing } from "lucide-react";
import { Switch } from "./ui/switch";

const CHANNELS = [
    { key: "email", label: "E-mail", icon: Mail, hint: "" },
    { key: "push", label: "Push (navegador)", icon: BellRing, hint: "" },
    { key: "whatsapp", label: "WhatsApp", icon: MessageCircle, hint: "em breve" },
    { key: "sms", label: "SMS", icon: Smartphone, hint: "em breve" },
];

// Controlled toggles for the 4 notification channels.
export const ChannelToggles = ({ prefs, onToggle, idPrefix = "" }) => (
    <div className="grid grid-cols-1 gap-2 sm:grid-cols-2">
        {CHANNELS.map((c) => (
            <div key={c.key} className="flex items-center justify-between rounded-xl border border-border/70 bg-muted/30 px-3 py-2.5">
                <span className="flex flex-1 items-center gap-2 text-sm">
                    <c.icon className="h-4 w-4 shrink-0 text-primary" /> {c.label}
                    {c.hint && <span className="shrink-0 whitespace-nowrap rounded-full bg-secondary/40 px-2 py-0.5 text-[10px] font-medium uppercase tracking-wide text-secondary-foreground">{c.hint}</span>}
                </span>
                <Switch data-testid={`${idPrefix}notif-${c.key}`} checked={!!prefs?.[c.key]} onCheckedChange={(v) => onToggle(c.key, v)} />
            </div>
        ))}
    </div>
);
